/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-01-10 16:21:38
 */

import AlarmLog from '../alarmLog';
import { Toast } from 'src/util/toast';
import { default as CellOperate } from 'src/components/agGridComponent/cellOperate';
import { IconBtnItem } from 'src/components/iconBtnGroup/iconBtnGroup';
import { ColDefCustom, default as AgGridVueCustomTsx } from 'src/components/agGridCustom/agGridVueCustomTsx';
import AlarmLogApi, { AlarmLogDOI } from '../api/alarmLogApi';
import _ from 'lodash';
import ListPageService from 'src/types/ListPage';
import override from 'src/dectorators/override';
import { QueryFormVOI } from 'src/components/queryForm/queryForm';
import EntitySelect from 'src/components/SelectCustom/entitySelect';
import EnumEntity from 'src/enums/enumEntity';
import CommonSelect from 'src/components/SelectCustom/commonSelect';
import DatePicker from 'src/types/iview/DatePicker';
import { DateTimeUtil } from 'src/util/dateTimeUtil';
import EnumAlarmLogType from 'src/enums/enumAlarmLogType';
import FileUtil from 'src/util/fileUtil';

export default class AlarmLogService extends ListPageService {
    ctx: AlarmLog;

    constructor(ctx: AlarmLog) {
        super();
        this.ctx = ctx;
    }

    @override
    createColumns(): ColDefCustom[] {
        let t = this;
        return [
            {
                headerName: '时间',
                field: 'datatime',
                minWidth: 170,
            },
            {
                headerName: '报警类型',
                field: 'alarm_type',
                minWidth: 100,
                cellRenderer(params) {
                    let data = params.data;
                    return EnumAlarmLogType.findId(data.alarm_type).getName();
                },
            },
            {
                headerName: '报警内容',
                field: 'alarm_content',
                minWidth: 190,
            },
            {
                headerName: '原始编码',
                field: 'original_code',
                minWidth: 190,
            }
        ];
    }

    @override
    creatQueryForm(): QueryFormVOI.DateItemType[] {
        return [
            {
                component: EntitySelect,
                label: '组分',
                field: 'component',
                labelWidth: 60,
                width: 160,
                props: { value: null, type: EnumEntity.Component.getId(), searchParams: { mn: this.ctx.$route.query.mn } },
            },
            {
                component: CommonSelect,
                label: '报警类型',
                field: 'alarm_type',
                labelWidth: 60,
                width: 160,
                props: { value: '', dataSource: EnumAlarmLogType.getList() },
            },

            {
                component: DatePicker,
                label: '时间',
                field: 'time',
                labelWidth: 60,
                width: 250,
                timeType: 'number',
                realField: ['start_time', 'end_time'],
                props: {
                    value: DateTimeUtil.getDayInterval(7),
                    type: 'daterange',
                    options: {
                        shortcuts: [
                            {
                                text: '最近1天',
                                value() {
                                    return DateTimeUtil.getDayInterval(1);
                                },
                            },
                            {
                                text: '最近7天',
                                value() {
                                    return DateTimeUtil.getDayInterval(7);
                                },
                            },
                            {
                                text: '最近30天',
                                value() {
                                    return DateTimeUtil.getDayInterval(30);
                                },
                            },
                        ],
                    },
                    placeholder: '请选择时间',
                },
            },
        ];
    }
    @override
    createBtnGroup(): Array<IconBtnItem> {
        let t = this;
        return [
            {
                text: '导出',
                type: 'info',
                async onClick() {
                    let { code, data } = await AlarmLogApi.exportAll(t.ctx.queryForm.getQueryObj<AlarmLogDOI.QueryRowDataParamsI>());
                    if (code === 0) {
                        FileUtil.download(data.download_url);
                    }
                },
            },
        ];
    }

    @override
    initSearchParams(): void {
        this.ctx.searchParams = this.ctx.queryForm.getQueryObj<AlarmLogDOI.QueryRowDataParamsI>();
        this.ctx.currentPage = 1;
    }

    @override
    async searchTable() {
        let ctx = this.ctx;
        let ag = this.ctx.$refs.ag as AgGridVueCustomTsx;
        ag.showLoading();
        let { code, data } = await AlarmLogApi.searchList({
            ...ctx.searchParams,
            page_size: ctx.pageSize,
            page_index: ctx.currentPage,
            mn: this.ctx.$route.query.mn
        });
        ag.hideLoading();

        if (code === 0) {
            ctx.rowData = data.data_info || [];
            ctx.total = data.page_count;
        }
    }
}
